function pathJoin(a, b) {
	return a == "/" ? "/" + b : (a || "") + "/" + b;
}

module.exports = pathJoin;



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-middleware/lib/PathJoin.js
// module id = 1877
// module chunks = 0